module.exports = __webpack_public_path__ + "static/blog71-8c65eca4fa5278f4dbe42824e3e8760e.png";